import Grid from '@mui/material/Grid';
import React, {useState} from 'react';
import AgyleTextField from '../../../components/ui/fields/agyleTextField';
import {useTranslation} from 'react-i18next';
import MiniFormDialog from '../../../components/modal/miniFormDialog';
import AgyleButton from '../../../components/ui/buttons/agyleButton';

const CustomNoteModal = ({onClose, open, onChange, patient, patientType, disableSave, _formOptions}) => {
    const {t} = useTranslation();
    const [text, setText] = useState(patient?.metadata?.customNote || '');

    const createNote = () => {
        if (onChange) {
            onChange([{
                name: `metadata.customNote`,
                value: text,
                noteToAdd: `Custom note in Patient card - ${text}`,
            }]);
        }
        onClose();
    };

    const handleDeleteNote = () =>{
        if (onChange) {
            onChange([{
                name: `metadata.customNote`,
                value: "",
                noteToAdd: `Custom note in Patient card removed`,
            }]);
        }
        onClose();
    }

    const handleChangeText = (event) => {
        setText(event.target.value);
    };

    return (
        <>
            <MiniFormDialog
                title={`Custom note in Patient Card`}
                open={open}
                onClose={onClose}
                onSave={createNote}
                disableSubmit={ !text || disableSave}
                formOptions={_formOptions}
                buttons={[
                    <AgyleButton
                        variant="outlined"
                        onClick={handleDeleteNote}
                        key="add-note"
                    >
                        {t('Delete')}
                    </AgyleButton>,
                ]}

            >
                <Grid container direction="row" spacing={2}>

                    <Grid item xs={12}>
                        <AgyleTextField
                            name="text"
                            label={t('Custom Note')}
                            multiline
                            maxRows={5}
                            onChange={handleChangeText}
                            value={text}
                            fullWidth
                            noBorder={false}
                            maxLength={35}
                            withNewBackground
                            size="large"
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <div style={{fontStyle: "italic"}}> {t('Custom Note maximum 35 characters')} </div>
                    </Grid>
                </Grid>
            </MiniFormDialog>
        </>
    );
};

export default CustomNoteModal;